<template>
  <div>
    <basic-subheader>
      <template v-slot:filters>
        <b-row>
          <div class="p-4 mt-3">
            <basic-input label="Tên khách hàng | Số điện thoại" placeholder="Nhập tên khách hàng" name="name"
              class="route-input" :value="searchText" @v-modal:update="searchDebounce"></basic-input>
          </div>
          <!-- <div class="p-4 mt-4">
            <label for="createdtime">Ngày thêm</label>
            <date-picker
              :range="true"
              :clearable="false"
              input-class="form-control"
              type="date"
              format="DD/MM/YYYY"
              value-type="date"
              @change="searchDate"
              v-model="filter.createDatetime"
            />
          </div> -->
        </b-row>
      </template>

      <!-- <template v-slot:actions>
          <b-button v-if="isWriteAllPermission || isWriteOwnerPermission" class="btn btn-success mr-2"
            @click="importCustomer">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/File/file-download.svg" />
            </span>
            Import
          </b-button>
          <b-button v-if="isWriteAllPermission || isWriteOwnerPermission" class="btn btn-success" type="button"
            @click.stop="createCustomerReceive">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
            </span>
            Thêm mới
          </b-button>
          <modal-import @import-success="loadData(true)" />
        </template> -->
      <!-- <template v-slot:filters> -->
      <!-- <template>
        <b-row>
          <b-col class="mt-4 w-250">
            <basic-select
             :options="courses"
              name="course"
              label="Chọn khóa học có sẵn"
              :value="getNameOf('course', filter.courseId)"
              @update:value="selected($event, 'course', courses)"
              placeholder="-- Chọn khóa học -- "
              track-by="value"
              value-label="text"
              :hideSelected="true"
              :clear="true"
              :solid="false"
              changeValueByObject
            />
          </b-col>
          <b-col class="mt-4">
            <label for="createdtime">Thời gian diễn ra</label>
            <date-picker
              :range="true"
              :clearable="false"
              input-class="form-control"
              :default-value="Date.now()"
              type="date"
              format="DD/MM/YYYY"
              value-type="date"
              :disabled="true"
              v-model="filter.courseTime"
              @change="searchDate"
            />
          </b-col>
        </b-row>
      </template> -->
      <template v-slot:actions>
        <div>
          <!-- Toggle Đang tham gia / Đã hoàn thành -->
          <b-button-group style="margin-right: 10px; margin-top: 12px">
            <b-button
              :variant="participationFilter === 'active' ? 'success' : 'outline-success'"
              @click="setParticipationFilter('active')"
            >
              Đang tham gia
            </b-button>
            <b-button
              :variant="participationFilter === 'completed' ? 'success' : 'outline-success'"
              @click="setParticipationFilter('completed')"
            >
              Đã hoàn thành
            </b-button>
          </b-button-group>

          <!-- <b-button
            class="btn btn-success ml-2 mt-3"
            @click="toggleSelect"
          >
            {{ buttonName }}
          </b-button> -->

          <b-dropdown
            id="dropdown-right dropdown-form"
            class="dropdown-form-filter mt-4"
            no-caret
            right
          >
            <template #button-content>
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Bộ lọc
            </template>
            <h6 class="d-flex align-items-center mb-0 p-4">
              <span class="svg-icon mr-3">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Bộ lọc
            </h6>

            <b-dropdown-divider> </b-dropdown-divider>

            <b-container>
              <!-- Row 1: Coach, Trạng thái -->
              <b-row>
                <b-col cols="6">
                  <label>Coach phụ trách</label>
                  <basic-select
                    placeholder="Chọn coach"
                    name="coachFilter"
                    :solid="false"
                    changeValueByObject
                    trackBy="value"
                    valueLabel="text"
                    :options="coaches"
                    class="filter mb-0"
                    :value.sync="filter.coachIds"
                    :multiple="true"
                    :clear="true"
                    @update:value="onCoachFilterChange"
                  />
                </b-col>
                <b-col cols="6">
                  <label>Trạng thái</label>
                  <basic-select
                    placeholder="Chọn trạng thái"
                    name="status"
                    :solid="false"
                    changeValueByObject
                    trackBy="value"
                    valueLabel="text"
                    :options="optionsStatus"
                    class="filter mb-0"
                    :value.sync="filter.status"
                    :clear="true"
                    @update:value="
                      selected($event, 'status', optionsStatus, null, 2)
                    "
                  />
                </b-col>
              </b-row>
              <!-- Row 2: Thời gian tham gia, Đăng nhập -->
              <b-row class="mt-3">
                <b-col cols="6">
                  <label>Thời gian tham gia</label>
                  <date-picker
                    :range="true"
                    :clearable="true"
                    input-class="form-control"
                    type="date"
                    format="DD/MM/YYYY"
                    value-type="date"
                    v-model="filter.participationTime"
                    placeholder="Chọn khoảng thời gian"
                  />
                </b-col>
                <b-col cols="6">
                  <label>Đăng nhập</label>
                  <basic-select
                    placeholder="Chọn trạng thái"
                    name="loginFlag"
                    :solid="false"
                    changeValueByObject
                    trackBy="value"
                    valueLabel="text"
                    :options="optionsFlag"
                    class="filter mb-0"
                    :value.sync="filter.loginFlag"
                    @update:value="
                      selected($event, 'loginFlag', optionsFlag, null, 2)
                    "
                  />
                </b-col>
              </b-row>
              <!-- Row 3: Nhóm Zalo, Nhóm onboard -->
              <b-row class="mt-3">
                <b-col cols="6">
                  <basic-select
                    label="Nhóm Zalo"
                    placeholder="Tất cả"
                    :options="zaloGroupFilterOptions"
                    track-by="value"
                    value-label="text"
                    :value.sync="filter.zaloGroupId"
                  />
                  <basic-select
                    v-if="filter.zaloGroupId === 'SHARED_ZALO_GROUP'"
                    class="mt-3"
                    label="Tên nhóm chung"
                    placeholder="Tất cả nhóm chung"
                    name="sharedZaloGroup"
                    :options="sharedZaloGroupOptions"
                    track-by="value"
                    value-label="text"
                    :value.sync="filter.sharedZaloGroupId"
                    :clear="true"
                  />
                </b-col>
                <b-col cols="6">
                  <basic-select
                    label="Nhóm onboard"
                    placeholder="Tất cả"
                    name="onboardGroup"
                    :options="onboardGroupOptions"
                    track-by="value"
                    value-label="text"
                    class="filter mb-0"
                    :value.sync="filter.onboardGroup"
                    :clear="true"
                  />
                </b-col>
              </b-row>
            </b-container>
            <b-dropdown-divider> </b-dropdown-divider>

            <div
              class="d-flex align-items-center justify-content-lg-end m-0 p-4 flex-wrap"
            >
              <b-button
                v-if="isViewPermission"
                class="btn btn-success ml-2 mb-2"
                @click.stop="showZaloListModal"
              >
                Danh sách nhóm
              </b-button>

              <b-button
                class="btn ml-2 mb-2"
                href="#"
                tabindex="0"
                @click="resetRequest"
              >
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                  />
                </span>
                Làm mới
              </b-button>

              <b-button
                class="btn btn-success ml-2 mb-2"
                href="#"
                tabindex="0"
                @click="searchRequest"
              >
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Lọc dữ liệu
              </b-button>
            </div>
          </b-dropdown>
        </div>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <div class="customer-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0 p-4 table-responsive">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :searchAction="false"
                  :selectAction="false"
                  :scrollDown="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td class="text-overflow">
                      <strong>
                        <p class="mb-0">
                          {{ item.name }}
                          <span v-if="item.zaloVerify === true">
                            <i
                              class="fa fa-check-circle text-success"
                              aria-hidden="true"
                            ></i>
                          </span>
                          <span v-if="!item.zaloGroupId || item.zaloGroupId === 'NO_ZALO_GROUP'" class="badge-no-zalo">Không nhóm</span>
                          <span v-else-if="sharedZaloGroupCount(item) > 1 || isSharedZaloGroup(item)"
                            class="badge-shared-group" :title="`Nhóm Zalo: ${item.zaloGroupId}`">Nhóm chung</span>
                          <span v-if="item.status === 2" class="badge badge-success ml-1">Hoàn thành</span>
                        </p>
                      </strong>
                      <!-- Package info cards -->
                      <div class="package-info-cards mt-1" v-if="accountData[item.phoneNumber] || userPackageData[item.phoneNumber]?.tranServicePackageName || userPackageData[item.phoneNumber]?.packageName">
                        <div class="package-card package-card--old" v-if="accountData[item.phoneNumber]">
                          <span class="package-card__value">{{ accountData[item.phoneNumber] }}</span>
                        </div>
                        <div class="package-card package-card--new" v-if="userPackageData[item.phoneNumber]?.tranServicePackageName">
                          <span class="package-card__label">service:</span>
                          <span class="package-card__value">{{ userPackageData[item.phoneNumber]?.tranServicePackageName }}</span>
                        </div>
                        <div class="package-card package-card--package" v-if="userPackageData[item.phoneNumber]?.packageName">
                          <span class="package-card__label">package:</span>
                          <span class="package-card__value">{{ userPackageData[item.phoneNumber]?.packageName }}</span>
                        </div>
                      </div>
                    </td>

                    <td class="text-center mw-200">
                      <basic-select
                        placeholder="Chọn coach"
                        name="coach"
                        :solid="false"
                        changeValueByObject
                        :hideSelected="true"
                        trackBy="value"
                        valueLabel="text"
                        :options="renderCoaches(item.courseId)"
                        class="filter mb-0"
                        :value="getNameOf('coach', item.coachId)"
                        :clear="false"
                        @update:value="
                          selected($event, 'coachId', coaches, item)
                        "
                      />
                    </td>
                    <!-- <td class="text-center mw-200">
                      <basic-select
                        placeholder="Chọn partner"
                        name="partner"
                        :solid="false"
                        changeValueByObject
                        :hideSelected="true"
                        trackBy="value"
                        valueLabel="value"
                        :options="partners"
                        class="filter mb-0 partner"
                        :value="getNameOf('partner', item.customerPartnerId)"
                        :clear="false"
                        @update:value="
                          selected($event, 'customerPartnerId', partners, item)
                        "
                      />
                    </td> -->
                    <!-- <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.downloadAppFlag"
                          @change="
                            handleChangeCheckbox(
                              $event,
                              item,
                              'downloadAppFlag',
                            )
                          "
                          :disabled="true"
                        ></v-checkbox>
                      </div>
                    </td> -->
                    <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.loginFlag"
                          @change="
                            handleChangeCheckbox($event, item, 'loginFlag')
                          "
                          :disabled="true"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.boardingBookingFlag"
                          @change="
                            handleChangeCheckbox(
                              $event,
                              item,
                              'boardingBookingFlag',
                            )
                          "
                          :disabled="true"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.boardingTestingFlag"
                          @change="
                            handleChangeCheckbox(
                              $event,
                              item,
                              'boardingTestingFlag',
                            )
                          "
                          :disabled="true"
                        ></v-checkbox>
                      </div>
                    </td>
                    <!-- <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.boardingDoneFlag"
                          @change="
                            handleChangeCheckbox(
                              $event,
                              item,
                              'boardingDoneFlag',
                            )
                          "
                        ></v-checkbox>
                      </div>
                    </td> -->
                    <!-- <td class="text-center">
                      <button
                        class="navi-link cursor-pointer btn btn-success"
                        v-b-toggle="'dsmes-submenu-' + item.id"
                        v-if="
                          item.dsmesWorkflowProcessId !==
                          '00000000-0000-0000-0000-000000000000'
                        "
                        @click="handleClickDetailDsmes(item)"
                        :disabled="isOpened"
                      >
                        <span class="menu-icon svg-icon svg-icon-sm text-white">
                          <inline-svg
                            class="svg-icon"
                            src="/media/svg/icons/Neolex/Basic/eye.svg"
                          />
                        </span>
                        Đã thực hiện
                      </button>
                    </td> -->
                    <td style="white-space: nowrap; text-align: center">
                      <!-- UserPackage week display from TranUserPackage API -->
                      <div v-if="userPackageData[item.phoneNumber]?.inWeek" class="week-card">
                        <div class="week-card__day">
                          <span class="week-card__label">Ngày</span>
                          <span class="week-card__value">{{ userPackageData[item.phoneNumber]?.inWeek?.day }}</span>
                        </div>
                        <div class="week-card__week">
                          <span class="week-card__label">Tuần</span>
                          <span class="week-card__value">
                            {{ userPackageData[item.phoneNumber]?.inWeek?.week }}<span v-if="userPackageData[item.phoneNumber]?.inWeek?.totalWeeks">/{{ userPackageData[item.phoneNumber]?.inWeek?.totalWeeks }}</span>
                          </span>
                        </div>
                      </div>
                      <!-- Old code - comment out
                      <div v-if="!showSelect">
                        {{
                          listWeeks[item.phoneNumber]?.length -
                          currentWeeks[item.phoneNumber]?.length +
                          1
                        }}/{{ listWeeks[item.phoneNumber]?.length }}
                      </div>
                      <div v-else>
                        <basic-select
                          required
                          track-by="value"
                          value-label="label"
                          placeholder="Chọn tuần"
                          name="listWeeks"
                          :options="listWeeks[item.phoneNumber] || []"
                          :multiple="false"
                          v-model="selectedWeek"
                          @update:value="
                            selected(
                              $event,
                              'listWeeksValue',
                              { ...currentSelectedItem[item.phoneNumber], customerName: item.name },
                              item,
                              3,
                            )
                          "
                          :solid="false"
                          class="filter mb-0"
                        />
                      </div>
                      -->
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center">
                        <v-checkbox
                          color="#008479"
                          dense
                          class="checkbox-role"
                          v-model="item.isDisplayedWelcome"
                          :disabled="!!loadingWelcome[item.accountId]"
                          @change="updateIsDisplayedWelcome(item, $event)"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_copy="false"
                        :show_view="false"
                        :show_edit="false"
                        :show_delete="false"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        class="dropdown-form-filter"
                      >
                        <!-- Level 1: Danh sách tiềm năng -->
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-danger"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span class="navi-text text-danger">
                              Danh sách tiềm năng
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider />
                        <!-- Level 1: Hoàn thành / Danh sách tiếp nhận -->
                        <b-dropdown-text
                          v-if="isUpdatePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="toggleCompletionStatus(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="item.status === 1 ? 'text-success' : 'text-primary'"
                            >
                              <inline-svg
                                class="svg-icon"
                                :src="item.status === 1 ? '/media/svg/icons/Neolex/Basic/check-circle.svg' : '/media/svg/icons/Neolex/Basic/arrow-left.svg'"
                              />
                            </span>
                            <span
                              class="navi-text"
                              :class="item.status === 1 ? 'text-success' : 'text-primary'"
                            >
                              {{ item.status === 1 ? 'Hoàn thành' : 'Danh sách tiếp nhận' }}
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider />
                        <!-- Level 1: Xem chi tiết -->
                        <b-dropdown-text tag="div" class="navi-item cursor-pointer" @click="detailCustomer(item)">
                          <a class="navi-link text-primary">
                            <span class="menu-icon svg-icon svg-icon-sm">
                              <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/eye.svg" />
                            </span>
                            <span class="navi-text text-primary">Xem chi tiết</span>
                          </a>
                        </b-dropdown-text>
                        <template v-if="(!item.zaloGroupId || item.zaloGroupId === 'NO_ZALO_GROUP') && (item.status === 1 || item.status === 2)">
                          <b-dropdown-divider />
                          <b-dropdown-text
                            v-if="isUpdatePermission"
                            tag="div"
                            class="navi-item cursor-pointer"
                            @click="openEnableZaloModal(item)"
                          >
                            <a class="navi-link text-primary">
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/circle-plus.svg" />
                              </span>
                              <span class="navi-text text-primary">Tạo nhóm Zalo</span>
                            </a>
                          </b-dropdown-text>
                        </template>
                        <!-- Khách đang dùng chung nhóm Zalo: tách ra nhóm riêng -->
                        <template v-if="sharedZaloGroupCount(item) > 1 && (item.status === 1 || item.status === 2)">
                          <b-dropdown-divider />
                          <b-dropdown-text
                            v-if="isUpdatePermission"
                            tag="div"
                            class="navi-item cursor-pointer"
                            @click="openEnableZaloModal(item, true)"
                          >
                            <a class="navi-link text-primary">
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/circle-plus.svg" />
                              </span>
                              <span class="navi-text text-primary">Tạo nhóm cá nhân</span>
                            </a>
                          </b-dropdown-text>
                        </template>
                        <b-dropdown-divider v-if="item.zaloGroupId && item.zaloGroupId !== 'NO_ZALO_GROUP'" />
                        <!-- Level 1: Gửi link đặt hẹn -->
                        <b-dropdown-text
                          v-if="isInsertPermission && item.zaloGroupId !== 'NO_ZALO_GROUP'"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="selected($event, 'bookingSend', item, item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/send.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Gửi link đặt hẹn
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider v-if="item.zaloGroupId !== 'NO_ZALO_GROUP'" />
                        <!--Gia hạn gói dịch vụ-->
                         <b-dropdown-text
                          v-if="isUpdatePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="selected($event, 'renewService', item, item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Gia hạn gói dịch vụ
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider />
                        <!-- Level 1: Xem hoạt động -->
                        <b-dropdown-text
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="goToUserPackageActivity(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/calendar.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Xem hoạt động
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider />
                        <!-- Level 1: Lấy link nhóm -->
                        <!-- <b-dropdown-text
                          tag="div"
                          class="navi-item cursor-pointer"
                          @click="copyGroupLink(item)"
                        >
                          <a class="navi-link text-primary">
                            <span class="menu-icon svg-icon svg-icon-sm">
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/copy.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Lấy link nhóm
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider /> -->
                        <!-- Level 1: Mở link nhóm Zalo -->
                        <b-dropdown-text
                          v-if="item.zaloGroupId !== 'NO_ZALO_GROUP'"
                          tag="div"
                          class="navi-item cursor-pointer"
                          @click="openZaloGroupLink(item)"
                        >
                          <a class="navi-link text-primary">
                            <span class="menu-icon svg-icon svg-icon-sm">
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/external-link.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Mở link nhóm Zalo
                            </span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-divider />
                        <!-- Level 2: Submenu Thêm -->
                        <b-dropdown-text
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            v-b-toggle="'more-submenu-' + item.id"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/more-horizontal.svg"
                              />
                            </span>
                            <span class="navi-text text-primary">
                              Xem thêm
                            </span>
                            <span class="ml-auto">
                              <inline-svg
                                class="svg-icon svg-icon-sm"
                                src="/media/svg/icons/Neolex/Arrows/chevron-down.svg"
                              />
                            </span>
                          </a>
                          <b-collapse
                            :id="'more-submenu-' + item.id"
                            class="mt-2 ml-3 submenu-level2"
                          >
                            <!-- Level 2: Phiếu thông tin -->
                            <a
                              v-if="isInsertPermission"
                              class="navi-link cursor-pointer d-flex align-items-center py-2"
                              @click="addItemDsmes(item)"
                            >
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/plus.svg"
                                />
                              </span>
                              <span class="navi-text text-primary">Phiếu thông tin</span>
                            </a>
                            <!-- Level 2: Phiếu khảo sát -->
                            <a
                              v-if="isInsertPermission"
                              class="navi-link cursor-pointer d-flex align-items-center py-2"
                              @click="opentSurveyResult(item)"
                            >
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/plus.svg"
                                />
                              </span>
                              <span class="navi-text text-primary">Phiếu khảo sát</span>
                            </a>
                            <!-- Level 2: Xem file đã tải -->
                            <a
                              class="navi-link cursor-pointer d-flex align-items-center py-2"
                              @click="detailCustomerFile(item)"
                            >
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/eye.svg"
                                />
                              </span>
                              <span class="navi-text text-primary">Xem file đã tải</span>
                            </a>
                            <!-- Level 2: Tư vấn -->
                            <a
                              v-if="item.isZaloLinked == null"
                              class="navi-link cursor-pointer d-flex align-items-center py-2"
                              @click="handleCall(item)"
                            >
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Call/call-phone.svg"
                                />
                              </span>
                              <span class="navi-text text-primary">Tư vấn</span>
                            </a>
                            <!-- Level 2: Trạng thái -->
                            <a
                              class="navi-link cursor-pointer d-flex align-items-center py-2"
                              v-b-toggle="'status-submenu-' + item.id"
                            >
                              <span class="menu-icon svg-icon svg-icon-sm text-primary">
                                <inline-svg
                                  class="svg-icon"
                                  src="/media/svg/icons/Neolex/Basic/settings.svg"
                                />
                              </span>
                              <span class="navi-text text-primary">Trạng thái</span>
                            </a>
                            <b-collapse
                              :id="'status-submenu-' + item.id"
                              class="mt-2"
                            >
                              <basic-select
                                placeholder="Chọn trạng thái"
                                name="status"
                                :solid="false"
                                changeValueByObject
                                :hideSelected="true"
                                trackBy="value"
                                valueLabel="text"
                                :options="optionsStatus"
                                class="filter mb-0"
                                :value="getNameOf('status', item.status)"
                                :clear="false"
                                dropup
                                @update:value="
                                  selected($event, 'status', optionsStatus, item)
                                "
                              />
                            </b-collapse>
                          </b-collapse>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal
        v-model="isModalVisible"
        title="Xác nhận hành động"
        @hide="resetModal"
        :no-close-on-backdrop="true"
        size="lg"
      >
        <div style="display: inline; font-size: 14px">
          <p>
            {{ this.messageUser }}<br />
            <b>{{ this.selectedItemModalName }}</b>
          </p>
        </div>
        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            @click="closedModal"
            :disabled="loading"
          >
            Đóng
          </b-button>
          <b-button
            class="btn btn-success ml-2"
            @click="confirmSendSms"
            :disabled="loading"
          >
            Xác nhận
          </b-button>
        </template>
      </b-modal>
      <reason-question
        :targetItem="currentItem"
        :title="'Lý do chuyển người dùng thành khách hàng tiềm năng'"
        @load-data="loadData"
      />
      <call-client :targetItem="currentItem" @load-data="loadData" />
      <form-modal :targetItem="currentItem" :coachList="coachList" />
      <file-upload-modal :targetItem="currentItem" @load-data="loadData" />
      <zalo-list-user-modal @load-data="loadData" />
      <zalo-list-modal />
      <modal-survey-result :targetItem="currentItem" />
      <modal-detail :targetItem="currentItem" @load-data="loadData" :packagesName="packagesName" />
      <!-- Modal tạo nhóm Zalo cho KH None Group -->
      <b-modal
        v-model="enableZaloModal.show"
        :title="enableZaloModal.individual ? 'Tạo nhóm cá nhân' : 'Tạo nhóm Zalo'"
        size="md"
        centered
        :no-close-on-backdrop="true"
        :hide-header-close="true"
      >
        <b-overlay :show="enableZaloModal.loading">
          <div class="text-center py-2">
            <p class="mb-1">
              {{ enableZaloModal.individual
                ? 'Xác nhận tạo nhóm Zalo cho khách hàng đã có nhóm chung'
                : 'Xác nhận tạo nhóm Zalo cho khách hàng' }}
            </p>
            <p class="font-weight-bold mb-3">{{ enableZaloModal.item && enableZaloModal.item.name }}</p>
            <div
              class="d-inline-flex align-items-center px-3 py-2 rounded"
              :style="enableZaloModal.remain === 0 ? 'background:#fff7ed;border:1px solid #f59e0b;' : 'background:#f0fdf4;border:1px solid #17c653;'"
            >
              <span class="text-muted mr-2" style="font-size:13px;">Nhóm khả dụng:</span>
              <span
                class="font-weight-bold"
                :class="enableZaloModal.remain === 0 ? 'text-warning' : 'text-success'"
                style="font-size:18px;"
              >
                {{ enableZaloModal.remain !== null ? enableZaloModal.remain : '...' }}
              </span>
              <span class="text-muted ml-1" style="font-size:13px;">nhóm</span>
            </div>
            <p v-if="enableZaloModal.remain === 0" class="text-warning mt-2 mb-0" style="font-size:13px;">
              Hệ thống sẽ tự động mua thêm 1 nhóm mới khi bạn xác nhận.
            </p>
          </div>
          <!-- Đặt tên nhóm tay; bấm "Bỏ qua" thì BE sinh tên tự động như cũ -->
          <div class="mt-3">
            <div class="d-flex justify-content-between align-items-end mb-1">
              <label class="m-0 font-weight-bold" style="font-size:15px;">Tên nhóm Zalo</label>
              <small :class="zaloGroupNameTooLong ? 'text-danger font-weight-bold' : 'text-muted'" style="font-size:13px;">
                {{ zaloGroupNameLength }}/50
              </small>
            </div>
            <b-form-input
              v-model="enableZaloModal.groupName"
              maxlength="120"
              :state="zaloGroupNameTooLong ? false : null"
              :disabled="enableZaloModal.loading"
              placeholder="DiaB - Tên khách - "
              style="font-size:18px;"
            />
            <b-form-invalid-feedback :state="zaloGroupNameTooLong ? false : null" style="font-size:13px;">
              Tên nhóm tối đa 50 ký tự (giới hạn của Zalo). Vui lòng rút gọn.
            </b-form-invalid-feedback>
            <small class="text-muted d-block mt-1" style="font-size:13px;">
              Tối đa 50 ký tự. Bấm <strong>Bỏ qua</strong> để dùng tên tự động:
              <em>DiaB - {{ (enableZaloModal.item && enableZaloModal.item.name) || 'Tên khách' }} - GÓI</em>
            </small>
          </div>
        </b-overlay>
        <template #modal-footer>
          <b-button variant="secondary" size="sm" @click="enableZaloModal.show = false" :disabled="enableZaloModal.loading">
            Huỷ
          </b-button>
          <b-button
            variant="outline-primary"
            size="sm"
            class="ml-2"
            :disabled="enableZaloModal.loading"
            @click="confirmEnableZalo(false)"
          >
            Bỏ qua
          </b-button>
          <b-button
            variant="success"
            size="sm"
            class="ml-2"
            :disabled="enableZaloModal.loading || zaloGroupNameTooLong"
            @click="confirmEnableZalo(true)"
          >
            Xác nhận
          </b-button>
        </template>
      </b-modal>

      <!-- Modal xem hoạt động gói dịch vụ -->
      <b-modal
        id="user-package-activity-modal"
        title="Hoạt động gói dịch vụ"
        size="xl"
        hide-footer
        @hidden="selectedAccountId = null"
      >
        <tran-user-package-embed
          v-if="selectedAccountId"
          :accountId="selectedAccountId"
        />
      </b-modal>
      <!-- Modal gia hạn gói dịch vụ -->
      <b-modal
        id="renew-service-modal"
        v-model="showRenewModal"
        title="Gia hạn gói dịch vụ"
        size="lg"
        :no-close-on-backdrop="true"
        :hide-header-close="false"
        @hide="resetRenewForm"
      >
        <b-overlay :show="renewLoading">
          <!-- Thông tin khách hàng -->
          <div class="renew-customer-info mb-4 p-3" style="background:#f0fdf4;border-radius:10px;border-left:4px solid #17c653;">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <i class="fas fa-user-circle text-success mr-2" style="font-size:1.2rem;"></i>
                <div>
                  <div class="font-weight-bold text-dark">{{ renewItem && renewItem.name }}</div>
                  <div class="text-muted" style="font-size:0.85rem;">{{ renewItem && renewItem.phoneNumber }}</div>
                </div>
              </div>
              <!-- Gói hiện tại -->
              <div v-if="latestPackage" class="text-right">
                <div class="text-muted" style="font-size:0.75rem;">Gói đang dùng</div>
                <span class="badge badge-info px-2 py-1" style="font-size:0.8rem;">{{ latestPackage.name }}</span>
              </div>
            </div>
          </div>

          <b-row>
            <!-- Tên gói mới -->
            <b-col cols="12" class="mb-3">
              <basic-input
                label="Tên gói mới"
                placeholder="Nhập tên gói mới..."
                name="renewName"
                v-validate="'required'"
                :value.sync="renewForm.name"
                :state="validateState('renewName')"
                :invalidFeedback="errors.first('renewName')"
              />
            </b-col>

            <!-- Gói dịch vụ -->
            <b-col cols="12" class="mb-3">
              <basic-select
                label="Gói dịch vụ"
                placeholder="--- Chọn gói dịch vụ ---"
                name="renewServicePackage"
                track-by="id"
                value-label="text"
                :options="servicePackages"
                :value.sync="renewServicePackageObj"
                v-model="renewServicePackageObj"
                changeValueByObject
                data-vv-validate-on="input|change"
                v-validate="'required'"
                :state="validateState('renewServicePackage')"
                :invalidFeedback="errors.first('renewServicePackage')"
              />
            </b-col>

            <!-- Loại nhắc nhở -->
            <b-col cols="12" class="mb-3">
              <basic-select
                label="Loại nhắc nhở"
                placeholder="Chọn loại nhắc nhở"
                name="renewReminderMethod"
                track-by="value"
                value-label="text"
                :options="reminderMethodOptions"
                :value.sync="renewReminderMethodObj"
                v-model="renewReminderMethodObj"
                changeValueByObject
                data-vv-validate-on="input|change"
                v-validate="'required'"
                :state="validateState('renewReminderMethod')"
                :invalidFeedback="errors.first('renewReminderMethod')"
              />
            </b-col>

            <!-- Ngày bắt đầu -->
            <b-col cols="6" class="mb-3">
              <basic-date-picker
                label="Ngày bắt đầu"
                placeholder="DD/MM/YYYY"
                name="renewStartDate"
                format="DD/MM/YYYY"
                :value.sync="renewForm.startDate"
                v-validate="'required'"
                :state="validateState('renewStartDate')"
                :invalidFeedback="errors.first('renewStartDate')"
              />
            </b-col>

            <!-- Ngày kết thúc (tự động tính) -->
            <b-col cols="6" class="mb-3">
              <basic-date-picker
                label="Ngày kết thúc"
                placeholder="DD/MM/YYYY"
                name="renewEndDate"
                format="DD/MM/YYYY"
                :value.sync="renewForm.endDate"
                :disabled="true"
                v-validate="'required'"
                :state="validateState('renewEndDate')"
                :invalidFeedback="errors.first('renewEndDate')"
              />
            </b-col>
          </b-row>
        </b-overlay>

        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end">
            <b-button variant="secondary" class="mr-2" @click="showRenewModal = false" :disabled="renewLoading">
              Hủy
            </b-button>
            <b-button class="btn btn-success" @click="submitRenew" :disabled="renewLoading">
              <span v-if="renewLoading" class="spinner-border spinner-border-sm mr-2"></span>
              <i v-else class="fas fa-check mr-2"></i>Xác nhận gia hạn
            </b-button>
          </div>
        </template>
      </b-modal>

    </b-overlay>
  </div>
</template>

<script>
const { mapState } = createNamespacedHelpers('customerReceives');
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { TAG_TYPE } from '@/core/plugins/constants';
import moment from 'moment-timezone';
import {
  // generateWeeklySegments,
  // getRemainingWeeks,
  // generateRemainWeeklySegments,
  extractStartDate,
  // extractEndDate,
  convertToTimestamp,
} from '@/core/utils/dateUtils';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { convertDateToTimestamp } from '@/core/mixins/index.js';
import { handleZaloOutOfMoney } from '@/core/utils/zaloOutOfMoney';

const ZALO_GROUP_NAME_MAX = 50;

export default {
  components: {
    DatePicker,
    'reason-question': () => import('./ReasonModal.vue'),
     'modal-detail': () => import('./DetailModal.vue'),
    'call-client': () => import('./CallModal.vue'),
    'form-modal': () =>
      import('@/view/pages/coaches_calendar/components/FormModal.vue'),
    'zalo-list-user-modal': () =>
      import('@/view/pages/courses/components/ZaloListAllUser.vue'),
    'zalo-list-modal': () =>
      import('@/view/pages/courses/components/ZaloListModal.vue'),
    'file-upload-modal': () =>
      import('@/view/pages/customer_receives/components/FileUploadModal.vue'),
    'modal-survey-result': () => import('./modal/ModalSurveyResult.vue'),
    'tran-user-package-embed': () => import('./TranUserPackageEmbed.vue'),
  },
  props: {
    searchParamsCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      groups: [
        {
          id: '1',
          name: 'ABC',
        },
      ],
      data: [],
      optionsFlag: [
        {
          text: 'Chưa đăng nhập',
          value: false,
        },
        {
          text: 'Đã đăng nhập',
          value: true,
        },
      ],
      optionsStatus: [
        {
          text: 'Đang tham gia',
          value: 1,
        },
        {
          text: 'Đã tham gia',
          value: 2,
        },
      ],
      optionsGender: [
        {
          text: 'Nam',
          value: 1,
        },
        {
          text: 'Nữ',
          value: 2,
        },
      ],
      selectedWeek: {},
      selectedCoach: 0,
      coaches: [],
      followOaFlag: false,
      SelectedWeeksTime: [],
      buttonName: 'Thay đổi lộ trình',
      participationFilter: 'active',
      searchText: null,
      zaloGroupFilterOptions: [
        { text: 'Tất cả', value: null },
        { text: 'Chưa có nhóm Zalo', value: 'NO_ZALO_GROUP' },
        { text: 'Nhóm chung', value: 'SHARED_ZALO_GROUP' },
      ],
      // Tên các nhóm chung, chỉ tải khi chọn "Nhóm chung" lần đầu
      sharedZaloGroupOptions: [],
      filter: {
        name: null,
        phoneNumber: null,
        zaloGroupId: null,
        sharedZaloGroupId: null,
        contactSource: null,
        status: null,
        followOaFlag: null,
        joinGroupchatFlag: null,
        downloadAppFlag: null,
        loginFlag: null,
        boardingBookingFlag: null,
        boardingTestingFlag: null,
        boardingDoneFlag: null,
        joinHeathCouseFlag: null,
        accountId: null,
        patientId: null,
        coachId: null,
        coachIds: [],
        customerPartnerId: null,
        courseName: null,
        courseId: null,
        courseTime: [null, null],
        gender: null,
        participationTime: null,
        onboardGroup: null,
      },
      packageNamed: null,
      packagesName: [],
      // Nhóm onboard cho dropdown lọc, lấy từ GET /CustomerReceives/OnboardGroups
      onboardGroupOptions: [],
      sort: {
        by: null,
        order: null,
      },
      column: [
        {
          key: 'name',
          label: 'Khách hàng',
          sortable: false,
          style: {
            'text-align': 'center',
            width: '15%',
          },
        },

        // {
        //   key: 'status',
        //   label: 'Trạng thái',
        //   sortable: false,
        //   style: {
        //     width: '10%',
        //     'text-align': 'center',
        //   },
        // },
        // {
        //   key: 'call',
        //   label: '',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },

        {
          key: 'coach',
          label: 'Coach',
          sortable: false,
          style: {
            width: '8%',
            'text-align': 'center',
          },
        },
        // {
        //   key: 'partner',
        //   label: 'Partner',
        //   sortable: false,
        //   style: {
        //     width: '8%',
        //     'text-align': 'center',
        //   },
        // },
        // {
        //   key: 'downloadAppFlag',
        //   label: 'Tải App',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        {
          key: 'loginFlag',
          label: 'Đăng nhập',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'boardingBookingFlag',
          label: 'Đặt lịch PVĐV',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'boardingTestingFlag',
          label: 'Thực hiện PVĐV',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        // {
        //   key: 'boardingDoneFlag',
        //   label: 'Hoàn thành PVĐV',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        // {
        //   key: 'dsmesFlag',
        //   label: 'Phiếu thông tin',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        // {
        //   key: 'weekToPackage',
        //   label: 'Tuần hiện tại',
        //   sortable: false,
        //   style: {
        //     width: '5%',
        //     'text-align': 'center',
        //   },
        // },
        {
          key: 'weekToPackage',
          label: 'Tuần hiện tại',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'isDisplayedWelcome',
          label: 'Hiển thị Welcome',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: '',
          label: '',
          sortable: false,
          style: {
            'text-align': 'center',
            width: '1%',
          },
        },
      ],
      isOpened: false,
      loading: false,
      loadingWelcome: {},
      selectedItems: [],
      currentItem: {},
      currenntCoach: {},
      selectedAccountId: null,
      notAllowUpdate: [],
      isModalVisible: false,
      selectedItemModalName: null,
      selectedItemModalPhoneNumber: null,
      disabled: false,
      messageUser: '',
      selectedItem: '',
      selectedKey: '',
      selectedEvent: '',
      accountData: {},
      userPackageData: {},
      isFetchingPackageInfo: false,
      lastFetchedAccountIds: null,
      listWeeks: {},
      currentWeeks: {},
      currentSelectedItem: {},
      enableZaloModal: {
        show: false,
        item: null,
        remain: null,
        loading: false,
        individual: false,
        groupName: '',
      },
      showRenewModal: false,
      renewItem: null,
      renewLoading: false,
      latestPackage: null,
      renewForm: {
        name: null,
        selectedServicePackage: null,
        reminderMethod: null,
        startDate: null,
        endDate: null,
      },
      servicePackages: [],
      allReminderMethodOptions: [
        { value: 0, text: 'Thông báo qua nhóm Zalo' },
        { value: 1, text: 'Thông báo qua ứng dụng DIAB' },
        { value: 2, text: 'Đồng thời qua nhóm Zalo và ứng dụng DIAB' },
        { value: 3, text: 'Không gửi thông báo' },
      ],
      showSelect: false,
      selectedOption: {},
      searchValue: ''
    };
  },
  computed: {
    // Zalo giới hạn tên nhóm 50 ký tự, đếm theo tên sau khi bỏ "-" thừa ở cuối như lúc gửi
    zaloGroupNameLength() {
      return (this.enableZaloModal.groupName || '').trim().replace(/[\s-]+$/, '').length;
    },
    zaloGroupNameTooLong() {
      return this.zaloGroupNameLength > ZALO_GROUP_NAME_MAX;
    },
    // Đếm khách dùng chung một nhóm Zalo trong trang hiện tại, theo zaloGroupId
    zaloGroupCounts() {
      const counts = {};
      (this.data || []).forEach((row) => {
        const groupId = row && row.zaloGroupId;
        if (!groupId || groupId === 'NO_ZALO_GROUP') return;
        counts[groupId] = (counts[groupId] || 0) + 1;
      });
      return counts;
    },
    ...mapState(['courses'/* , 'partners' */]),
    ...mapGetters(['currentUser']),
    reminderMethodOptions() {
      if (this.renewItem && this.renewItem.useZaloGroup === false) {
        return this.allReminderMethodOptions.filter((opt) => opt.value === 1 || opt.value === 3);
      }
      return this.allReminderMethodOptions;
    },
    searchParams() {
      const payload = this.removeEmpty({
        name: this.filter.name,
        status: this.filter.status,
        followOaFlag: this.filter.followOaFlag,
        joinGroupchatFlag: this.filter.joinGroupchatFlag,
        downloadAppFlag: this.filter.downloadAppFlag,
        loginFlag: this.filter.loginFlag,
        boardingBookingFlag: this.filter.boardingBookingFlag,
        boardingTestingFlag: this.filter.boardingTestingFlag,
        boardingDoneFlag: this.filter.boardingDoneFlag,
        joinHeathCouseFlag: this.filter.joinHeathCouseFlag,
        accountId: this.filter.accountId,
        patientId: this.filter.patientId,
        coachId: this.filter.coachId,
        customerPartnerId: this.filter.customerPartnerId,
        courseName: this.filter.courseName,
        // Chỉ gửi khi user thực sự chọn khoảng ngày — gửi mặc định [hôm nay, hôm nay]
        // sẽ rỗng khi server lệch múi giờ với client.
        startCourse: this.filter.courseTime?.[0]
          ? moment(this.filter.courseTime[0]).format('MM/DD/YYYY')
          : null,
        endCourse: this.filter.courseTime?.[1]
          ? moment(this.filter.courseTime[1]).format('MM/DD/YYYY')
          : null,
        phoneNumber: this.filter.phoneNumber,
        gender: this.filter.gender,
        // Chọn "Nhóm chung" mà có chọn tên nhóm thì lọc đúng nhóm đó
        zaloGroupId:
          this.filter.zaloGroupId === 'SHARED_ZALO_GROUP' && this.filter.sharedZaloGroupId
            ? this.filter.sharedZaloGroupId
            : this.filter.zaloGroupId,
        // BE khớp một phần (Contains) nên gõ vài ký tự là ra
        onboardGroup: this.filter.onboardGroup,
        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      if (this.filter.name || this.filter.phoneNumber) {
        params.append('statuses', '1');
        params.append('statuses', '2');
      } else {
        const statusValue = this.participationFilter === 'completed' ? '2' : '1';
        params.append('statuses', statusValue);
      }
      // Thời gian tham gia (filter by TimeAccepted)
      if (this.filter.participationTime && this.filter.participationTime[0]) {
        params.append('startTimeAccepted', moment(this.filter.participationTime[0]).format('MM/DD/YYYY'));
      }
      if (this.filter.participationTime && this.filter.participationTime[1]) {
        params.append('endTimeAccepted', moment(this.filter.participationTime[1]).format('MM/DD/YYYY'));
      }
      // Coach IDs (multiple)
      if (this.filter.coachIds && this.filter.coachIds.length > 0) {
        this.filter.coachIds.forEach(coach => {
          params.append('coachIds', coach.value);
        });
      }
      return params;
    },
    // weekProgress() {
    //   if (!this.listWeeks?.[this.selectedPhoneNumber]) {
    //     return { currentWeek: 0, totalWeeks: 0, ratio: '0/0' };
    //   }
    //   return getWeekProgress(this.listWeeks[this.selectedPhoneNumber]);
    // }

    // Computed cho basic-select trong modal gia hạn
    renewServicePackageObj: {
      get() {
        return this.servicePackages.find((o) => o.id === this.renewForm.selectedServicePackage) || null;
      },
      set(obj) {
        this.renewForm.selectedServicePackage = obj?.id ?? null;
      },
    },
    renewReminderMethodObj: {
      get() {
        return this.reminderMethodOptions.find((o) => o.value === this.renewForm.reminderMethod) || null;
      },
      set(obj) {
        this.renewForm.reminderMethod = obj?.value ?? null;
      },
    },
  },
  watch: {
    'renewForm.startDate': function(newVal) {
      if (newVal && this.renewForm.selectedServicePackage) {
        this.getRenewEndDate();
      }
    },
    'renewForm.selectedServicePackage': function(newVal) {
      if (newVal && this.renewForm.startDate) {
        this.getRenewEndDate();
      }
    },
    data(newData) {
      // Batch fetch user package info for all accounts
      this.fetchUserPackagesBatch(newData);
    },
    filterNoZalo() {
      this.loadData();
    },
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
    searchParamsCourse: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value != null) {
          this.filter.courseName = value.courseName;
        }
      },
    },
    'filter.zaloGroupId'(value) {
      if (value !== 'SHARED_ZALO_GROUP') {
        this.filter.sharedZaloGroupId = null;
        return;
      }
      if (!this.sharedZaloGroupOptions.length) {
        this.loadSharedZaloGroups();
      }
    },
    filter: {
      handler(newVal) {
        const { courseName, courseTime } = newVal;
        if (courseName || courseTime) {
          localStorage.setItem(
            'filterCourseData',
            JSON.stringify({
              courseName,
              courseTime,
            }),
          );
        }
      },
      deep: true,
    },
    selectedWeek(newDate, oldDate) {
      if (newDate === oldDate || this.selectedWeek === null) return;
      else {
        this.showModalForChangeWeeks(newDate, oldDate);
      }

      // You can add any additional logic here when the toggle state changes.
    },
  },

  methods: {
    copyGroupLink(item) {
      const link = item.zaloGroup || '';
      if (!link) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không tìm thấy link nhóm Zalo.',
        });
        return;
      }
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$toastr.s({
            title: 'Thành công!',
            msg: 'Đã sao chép link nhóm vào clipboard.',
          });
        })
        .catch((error) => {
          console.error('Lỗi khi sao chép:', error);
          this.$toastr.e({
            title: 'Lỗi!',
            msg: 'Không thể sao chép link.',
          });
        });
    },
    openZaloGroupLink(item) {
      const link = item.zaloGroup || '';
      if (!link) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không tìm thấy link nhóm Zalo.',
        });
        return;
      }
      window.open(link, '_blank');
    },
    setParticipationFilter(filterType) {
      this.participationFilter = filterType;
      this.paging.page = 1;
      this.loadData();
    },
    onCoachFilterChange(value) {
      // Chỉ ghi nhận lựa chọn. Việc lọc do nút "Lọc dữ liệu" quyết định, giống
      // các field còn lại trong bảng lọc.
      this.filter.coachIds = value || [];
    },
    formatPackageDate(timestamp) {
      if (!timestamp) return '';
      return moment(timestamp * 1000).format('DD/MM/YYYY');
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    async fetchUserPackagesBatch(items) {
      // Collect all accountIds
      const accountIds = items
        .filter(item => item.accountId)
        .map(item => item.accountId);

      if (accountIds.length === 0) return;

      // Prevent duplicate API calls
      const accountIdsKey = accountIds.sort().join(',');
      if (this.isFetchingPackageInfo || this.lastFetchedAccountIds === accountIdsKey) {
        return;
      }

      this.isFetchingPackageInfo = true;
      this.lastFetchedAccountIds = accountIdsKey;

      try {
        const response = await this.$api.post('/TranUserPackage/PackageInfoList', accountIds);
        const dataArray = response?.data || response || [];

        // Create a map of accountId -> package data
        const packageMap = {};
        dataArray.forEach(pkg => {
          if (pkg.accountId) {
            packageMap[pkg.accountId] = pkg;
          }
        });

        // Update userPackageData for each item
        items.forEach(item => {
          if (item.accountId && packageMap[item.accountId]) {
            const pkg = packageMap[item.accountId];
            // Parse inWeek string "Ngày X, tuần Y" to object format
            const inWeek = this.parseInWeekString(pkg.inWeek, pkg.totalWeek);
            this.$set(this.userPackageData, item.phoneNumber, {
              name: pkg.name,
              inWeek: inWeek,
              tranServicePackageName: pkg.tranServicePackageName,
              packageName: pkg.packageName,
            });
          }
        });
      } catch (error) {
        console.error('Error fetching user packages batch:', error);
      } finally {
        this.isFetchingPackageInfo = false;
      }
    },
    parseInWeekString(inWeekStr, totalWeek) {
      // Parse "Ngày X, tuần Y" format to { day, week, totalWeeks }
      if (!inWeekStr) return null;

      const match = inWeekStr.match(/Ngày\s*(\d+),\s*tuần\s*(\d+)/);
      if (!match) return null;

      const day = parseInt(match[1], 10);
      const week = parseInt(match[2], 10);

      return { day, week, totalWeeks: totalWeek || 0 };
    },
    async fetchUserPackageByAccountId(item) {
      const { phoneNumber, accountId } = item;
      if (!accountId) return;

      try {
        const response = await this.$api.get('/TranUserPackage/Coach/Account-detail', {
          params: { accountId }
        });

        // Response là array
        const dataArray = response?.data || response || [];

        if (dataArray?.length > 0) {
          // Lấy UserPackage đầu tiên (hoặc active)
          const data = dataArray.find(p => p.status === 1) || dataArray[0];

          // Tính inWeek từ startDate, dùng totalWeek từ API
          const inWeek = this.calculateInWeek(data.startDate, data.totalWeek);

          this.$set(this.userPackageData, phoneNumber, {
            name: data.name,
            inWeek: inWeek,
            tranServicePackageName: data.tranServicePackageName,
          });
        }
      } catch (error) {
        console.error('Error fetching user package by accountId:', error);
      }
    },
    calculateInWeek(startDate, totalWeek) {
      if (!startDate) return null;

      const now = Math.floor(Date.now() / 1000);
      const oneDay = 24 * 60 * 60;

      // Tính số ngày từ startDate đến hiện tại
      const daysPassed = Math.floor((now - startDate) / oneDay);
      const weeksPassed = Math.floor(daysPassed / 7);
      const dayInWeek = (daysPassed % 7) + 1;

      return {
        day: dayInWeek,
        week: weeksPassed + 1,
        totalWeeks: totalWeek || 0,
      };
    },
    async toggleCompletionStatus(item) {
      const newStatus = item.status === 1 ? 2 : 0;
      const actionText = newStatus === 2 ? 'hoàn thành' : 'danh sách tiếp nhận';

      const result = await this.$swal({
        title: 'Xác nhận',
        text: `Bạn có chắc chắn muốn chuyển khách hàng "${item.name}" sang trạng thái ${actionText}?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });

      if (result) {
        await this.changeStatus({
          ...item,
          status: newStatus,
        });
      }
    },
    showZaloModal() {
      this.$bvModal.show('zalo-list-user-modal');
    },
    showZaloListModal() {
      this.$bvModal.show('zalo-list-modal');
    },
    async updateIsDisplayedWelcome(item, value) {
      this.$set(this.loadingWelcome, item.accountId, true);
      try {
        await this.$api.put(
          `CustomerReceives/package-account/${item.accountId}/is-displayed-welcome`,
          JSON.stringify(value),
          { headers: { 'Content-Type': 'application/json' } },
        );
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật hiển thị Welcome thành công.',
        });
      } catch (error) {
        item.isDisplayedWelcome = !value;
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Cập nhật thất bại.',
        });
      } finally {
        this.$set(this.loadingWelcome, item.accountId, false);
      }
    },
      detailCustomer(item) {
      this.currentItem = item;
      this.$bvModal.show('customer-receive-detail-modal');
    },

    goToUserPackageActivity(item) {
      this.selectedAccountId = item.accountId;
      this.$bvModal.show('user-package-activity-modal');
    },

    detailCustomerFile(item) {
      this.currentItem = item;
      this.$bvModal.show('file-upload-modal');
    },

    async handleClickDetailDsmes(item) {
      try {
        this.isOpened = true;
        const response = await this.getDsmesInformation(
          item.dsmesWorkflowProcessId,
        );

        this.currentItem = response;
        this.coachList = this.coaches;
        this.$bvModal.show('form-modal');
      } finally {
        this.isOpened = false;
      }
    },

    async getDsmesInformation(id) {
      const params = new URLSearchParams({
        Id: id,
      });

      try {
        const { data } = await this.$api.get('/DsmesWorkFlow', {
          params,
        });

        return {
          data,
        };
      } catch (error) {
        console.error('Error fetching account details:', error);
        throw error;
      }
    },

    // individual = true: khách đang ở nhóm chung, tách ra nhóm riêng
    async openEnableZaloModal(item, individual = false) {
      this.enableZaloModal.item = item;
      this.enableZaloModal.individual = individual;
      // Fill sẵn phần đầu của mẫu tên tự động, admin chỉ việc gõ nốt phần đuôi
      this.enableZaloModal.groupName = `DiaB - ${(item && item.name ? item.name : '').trim()} - `;
      this.enableZaloModal.remain = null;
      this.enableZaloModal.loading = true;
      this.enableZaloModal.show = true;
      try {
        const { data } = await this.$api.get('/CustomerReceives/remainGroupZalo', { timeout: 60000 });
        this.enableZaloModal.remain = data;
      } catch {
        this.enableZaloModal.remain = null;
      } finally {
        this.enableZaloModal.loading = false;
      }
    },

    // Nhom Zalo dung chung -> badge "Nhom chung".
    // Uu tien so dem tu BE (dem tren TOAN bang): tu dem trong trang hien tai se ra 1
    // khi cac thanh vien khac cua nhom nam o trang/tab khac -> mat badge.
    sharedZaloGroupCount(item) {
      const groupId = item && item.zaloGroupId;
      if (!groupId || groupId === 'NO_ZALO_GROUP') return 0;
      if (typeof item.zaloGroupMemberCount === 'number') {
        return item.zaloGroupMemberCount;
      }
      return this.zaloGroupCounts[groupId] || 0;
    },
    isSharedZaloGroup(item) {
      if (!item) return false;
      if (item.isSharedZaloGroup === true) return true;
      return (
        !!item.zaloGroupId &&
        item.zaloGroupId !== 'NO_ZALO_GROUP' &&
        item.bypassCreateZaloGroup === true
      );
    },

    // useCustomName = false ("Bỏ qua"): không gửi groupName, BE sinh tên tự động như cũ
    async confirmEnableZalo(useCustomName = true) {
      if (!this.enableZaloModal.item) return;
      // Bỏ luôn dấu "-" thừa ở cuối prefix để tên nhóm không kết thúc bằng gạch ngang
      const customName = (this.enableZaloModal.groupName || '')
        .trim()
        .replace(/[\s-]+$/, '');
      if (useCustomName && !customName) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng nhập tên nhóm, hoặc bấm "Bỏ qua" để dùng tên tự động.',
        });
        return;
      }
      if (useCustomName && customName.length > ZALO_GROUP_NAME_MAX) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: `Tên nhóm tối đa ${ZALO_GROUP_NAME_MAX} ký tự, hiện tại ${customName.length} ký tự.`,
        });
        return;
      }
      this.enableZaloModal.loading = true;
      try {
        // Tách nhóm riêng dùng endpoint gọn: không chạy lại luồng chấp nhận
        const url = this.enableZaloModal.individual
          ? `/CustomerReceives/switch-individual-zalo/${this.enableZaloModal.item.id}`
          : `/CustomerReceives/enable-zalo/${this.enableZaloModal.item.id}`;
        await this.$api.put(url, undefined, {
          timeout: 60000,
          params: useCustomName ? { groupName: customName } : {},
        });
        this.$toastr.s({
          title: 'Thành công!',
          msg: this.enableZaloModal.individual
            ? 'Đã tách khách sang nhóm cá nhân.'
            : 'Đã tạo nhóm Zalo thành công.',
        });
        this.enableZaloModal.show = false;
        this.loadData();
      } catch (error) {
        if (await handleZaloOutOfMoney(this, error)) return;
        this.$toastr.e({ title: 'Lỗi!', msg: error.message || 'Không thể tạo nhóm.' });
      } finally {
        this.enableZaloModal.loading = false;
      }
    },

    async sendZNS() {
      this.messageUser = `Gửi link đặt hẹn đến khách hàng: ${this.selectedOption.optionsArr.name}`;
      this.isModalVisible = true;
      this.selectedItemModalPhoneNumber =
        this.selectedOption.optionsArr.phoneNumber;
    },
    handleStatus(status) {
      this.$emit('status-change', status);
      this.$root.$emit('bv::toggle::collapse', 'status-submenu');
    },

    showModalForChangeWeeks(newDate, oldDate) {
      // const startDay = extractStartDate(newDate);
      // const endDay = extractEndDate(newDate);

      this.messageUser = `Thay đổi lộ trình của khách hàng: ${this.SelectedWeeksTime.optionsArr.customerName || 'N/A'}`;
      this.selectedItemModalName = 'Từ ngày: ' + newDate;
      this.isModalVisible = true;
      console.log(`showSelect changed from ${oldDate} to ${newDate}`);
    },

    // TODO: Temporarily disabled - PackageAccountActived API
    // async fetchAccountData(item) {
    //   this.isLoading = true;
    //   this.error = null;

    //   try {
    //     const { phoneNumber, accountId, packageId } = item;

    //     const accountData = await this.getAccountDetails({
    //       accountId,
    //       packageId,
    //     });

    //     this.$set(this.accountData, phoneNumber, accountData.packageInfo?.name || 'N/A');
    //     this.$set(this.listWeeks, phoneNumber, accountData.weeklySegments);

    //     this.$set(this.currentWeeks, phoneNumber, accountData.remainSegment);
    //     this.$set(this.currentSelectedItem, phoneNumber, accountData.data);

    //     return accountData;
    //   } catch (error) {
    //     this.error = error.message || 'Error fetching account data';
    //     console.error('Error fetching account data:', error);
    //     throw error;
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    // async getAccountDetails({ accountId, packageId }) {
    //   const params = new URLSearchParams({
    //     AccountId: accountId,
    //     PackageId: packageId,
    //   });

    //   try {
    //     const { data } = await this.$api.get('/Package/PackageAccountActived', {
    //       params,
    //     });
    //     const {
    //       activationDate,
    //       expirationDate,
    //       package: packageInfo,
    //       createDatetime,
    //     } = data;

    //     // const startDate = new Date(activationDate * 1000);  // Convert activationDate to a Date object
    //     // const endDate = new Date(expirationDate * 1000);   // Convert expirationDate to a Date object

    //     // Calculate the difference in days between the start and end dates
    //     const diffDays = Math.ceil(
    //       (activationDate - expirationDate) / (1000 * 60 * 60 * 24),
    //     );

    //     const currentWeek = getRemainingWeeks(activationDate, expirationDate);
    //     // Generate weekly segments between the start and end dates
    //     const weeklySegments = generateWeeklySegments(
    //       createDatetime,
    //       expirationDate,
    //     );

    //     const remainSegment = generateRemainWeeklySegments(
    //       activationDate,
    //       expirationDate,
    //     );

    //     return {
    //       data,
    //       packageInfo,
    //       weeklySegments,
    //       remainSegment,
    //       duration: {
    //         // startDate: unixToDateString(activationDate),
    //         // endDate: unixToDateString(expirationDate),
    //         days: diffDays,
    //         currentWeek: currentWeek,
    //       },
    //     };
    //   } catch (error) {
    //     console.error('Error fetching account details:', error);
    //     throw error;
    //   }
    // },

    toggleSelect() {
      this.showSelect = !this.showSelect; // Toggle the boolean state
      this.buttonName = this.showSelect ? 'Thay đổi lộ trình' : 'Tuần hiện tại';
    },

    closedModal() {
      this.isModalVisible = false;
      this.clearDataBox();
      // this.selectedWeek = null
      // this.loadData();
      // this.UpdateAppFlags();
    },

    clearDataBox() {
      this.selectedItem = '';
      this.selectedKey = '';
      this.selectedEvent = '';
    },
    handleChangeCheckbox(event, item, key) {
      console.log("event, item, key", event, item, key)
      this.selectedItemModalName = item.name;
      this.messageUser = 'Bạn đang thay đổi dữ liệu của khách hàng: ';
      this.isModalVisible = true;
      this.selectedItem = item;
      this.selectedKey = key;
      this.selectedEvent = event;

      if (key === 'joinGroupchatFlag' && event === true) {
        this.messageUser = 'Gửi thông tin đăng nhập đến khách hàng: ';
        this.isModalVisible = true;
        this.selectedItemModalName = item.name;
        this.selectedItemModalPhoneNumber = item.phoneNumber;
      }
    },
    renderCoaches(courseId) {
      let rs = this.coaches.filter(
        (coach) => coach.courses && coach.courses.includes(courseId),
      );
      return rs;
    },
    searchDate() {
      if (
        this.filter.courseTime[0] == null &&
        this.filter.courseTime[1] == null
      ) {
        this.filter.courseTime = [
          moment().format('MM/DD/YYYY'),
          moment().format('MM/DD/YYYY'),
        ];
      }
      this.resetPaging();
    },

    formatCoursePeriod(startCourse, endCourse) {
      const formatDate = (date) => {
        if (!date) return null;
        const dateObj = new Date(date);
        if (isNaN(dateObj)) return null;
        return dateObj.toISOString().split('T')[0];
      };

      const formattedStart = formatDate(startCourse);
      const formattedEnd = formatDate(endCourse);

      if (formattedStart && formattedEnd) {
        return `${formattedStart} - ${formattedEnd}`;
      } else if (formattedStart) {
        return `${formattedStart} - Chưa xác định`;
      } else if (formattedEnd) {
        return `Chưa xác định - ${formattedEnd}`;
      } else {
        return 'Chưa xác định';
      }
    },
    handleCall(item) {
      this.currentItem = item;
      this.$bvModal.show('call-modal');
    },
    async searchRequest() {
      // Lọc mới thì phải về trang 1, nếu không đang ở trang 5 sẽ hỏi server trang 5
      // của kết quả mới và nhận về rỗng. Gán page rồi để watcher 'paging.page' gọi
      // loadData, tránh bắn 2 request.
      if (this.paging.page !== 1) {
        this.paging.page = 1;
      } else {
        this.loadData();
      }
      //  this.UpdateAppFlags();

      document.body.click();
    },
    // async UpdateAppFlags() {
    //   this.$store.commit('context/setLoading', true);
    //   try {
    //     await this.$api.get('Account/UpdateAppFlags');
    //     this.$toastr.s({
    //       title: 'Thành công!',
    //       msg: 'Cập nhật dữ liệu thành công',
    //     });
    //   } catch {
    //     this.$toastr.w({
    //       title: 'Cảnh báo',
    //       msg: 'Cập nhật dữ liệu thất bại',
    //     });
    //   } finally {
    //     this.$store.commit('context/setLoading', false);
    //   }
    // },
    async resetRequest() {
      this.filter.name = null;
      this.filter.phoneNumber = null;
      this.filter.contactSource = null;
      this.filter.status = null;
      this.filter.followOaFlag = null;
      this.filter.joinGroupchatFlag = null;
      this.filter.downloadAppFlag = null;
      this.filter.loginFlag = null;
      this.filter.boardingBookingFlag = null;
      this.filter.boardingTestingFlag = null;
      this.filter.boardingDoneFlag = null;
      this.filter.joinHeathCouseFlag = null;
      this.filter.accountId = null;
      this.filter.patientId = null;
      this.filter.coachId = null;
      this.filter.coachIds = [];
      this.filter.startCourse = null;
      this.filter.endCourse = null;
      this.filter.courseName = null;
      this.filter.gender = null;
      this.filter.participationTime = null;
      this.filter.onboardGroup = null;
      this.filter.zaloGroupId = null;
      this.filter.sharedZaloGroupId = null;
      //    this.UpdateAppFlags();
      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    selected(value, formProperty, optionsArr, item = null, type = 1) {
      this.selectedOption = { formProperty, optionsArr };
      console.log({
        value,
        formProperty,
        optionsArr,
      });
      if (formProperty === 'listWeeksValue') {
        this.SelectedWeeksTime = {
          value,
          optionsArr,
        };
      }

      if (formProperty == 'bookingSend') {
        this.sendZNS(optionsArr);
      }

      if (formProperty == 'renewService') {
        this.openRenewModal(optionsArr);
        return;
      }
      // if (formProperty == 'course') {
      //   this.filter.courseName = value?.text;
      //   this.resetPaging();
      //   if (Boolean(value?.startDatetime) && Boolean(value?.endDatetime)) {
      //     this.filter.courseTime = [
      //       moment(value?.startDatetime * 1000).toDate(),
      //       moment(value?.endDatetime * 1000).toDate(),
      //     ];
      //   } else {
      //     this.filter.courseTime = [
      //       moment().format('MM/DD/YYYY'),
      //       moment().format('MM/DD/YYYY'),
      //     ];
      //   }
      //   return;
      // }
      // if (formProperty === 'customerPartnerId' && value != null) {
      //   const selectedPartner = optionsArr.find(
      //     (el) => el.value === value?.value,
      //   );
      //   if (selectedPartner) {
      //     this.changeStatus({
      //       ...item,
      //       [formProperty]: selectedPartner.id, // Chỉ lấy id thay vì value
      //     });
      //   }
      //   return;
      // }

      const v = value
        ? optionsArr.find((el) => el.value === value?.value)
        : null;
      if (type == 1 && v != null && item != null) {
        this.changeStatus({
          ...item,
          [formProperty]: v.value,
        });
        return;
      }

      if (type == 2 && value != null) {
        this.filter[formProperty] = value?.value || false;
      }
    },
    viewItem(item) {
      this.$router.push({
        name: 'customer_receives_view',
        params: {
          id: item.id,
        },
      });
    },
    select(params) {
      this.$emit('select', params);
    },
    editItem(item) {
      this.$router.push({
        name: 'customer_receives_edit',
        params: {
          id: item.id,
          form_type: 'edit',
        },
      });
    },
    createItem() {
      this.$router.push({
        name: 'customer_receives_edit',
        params: {
          form_type: 'create',
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {},

    async openRenewModal(item) {
      this.renewItem = item;
      this.latestPackage = null;
      this.resetRenewForm();
      if (item.useZaloGroup === false) {
        this.renewForm.reminderMethod = 1;
      }

      // Load danh sách gói dịch vụ và goi API cùng lúc
      try {
        this.renewLoading = true;
        const requests = [];

        if (!this.servicePackages.length) {
          requests.push(
            this.$api.get('/servicePackage', { params: { size: 1000 } }).then((res) => {
              this.servicePackages = (res?.data?.items || res?.data || []).map((v) => ({
                id: v.id,
                text: v.name ?? v.description,
              }));
            }),
          );
        }

        // Gọi API lấy gói mới nhất của user
        if (item.accountId) {
          requests.push(
            this.$api.get(`/UserPackage/LatestUserPackage?accountId=${item.accountId}`)
              .then(({ data }) => {
                this.latestPackage = data;
                // Pre-fill form từ gói cũ
                this.renewForm.selectedServicePackage = data.servicePackageId || null;
                this.renewForm.name = data.name || null;
                // Nếu không có Zalo group, chỉ cho phép App
                if (item.useZaloGroup === false) {
                  const prev = data.reminderMethod;
                  this.renewForm.reminderMethod = (prev === 1 || prev === 3) ? prev : 1;
                } else {
                  this.renewForm.reminderMethod = data.reminderMethod ?? null;
                }
              })
              .catch(() => {
                // Không có gói cũ - bỏ qua
              }),
          );
        }

        await Promise.all(requests);
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Không thể tải dữ liệu' });
      } finally {
        this.renewLoading = false;
      }

      this.showRenewModal = true;
    },

    resetRenewForm() {
      this.renewForm = {
        name: null,
        selectedServicePackage: null,
        reminderMethod: null,
        startDate: null,
        endDate: null,
      };
      if (this.$validator) {
        this.$validator.reset();
      }
    },

    async getRenewEndDate() {
      if (!this.renewForm.selectedServicePackage || !this.renewForm.startDate) return;
      try {
        this.renewLoading = true;
        const startTimestamp = convertDateToTimestamp(this.renewForm.startDate);
        const { data } = await this.$api.get(
          `UserPackage/ServicePackageId?id=${this.renewForm.selectedServicePackage}&startDate=${startTimestamp}`,
        );
        const endDate = new Date(data * 1000);
        this.renewForm.endDate = `${endDate.getDate().toString().padStart(2, '0')}/${(endDate.getMonth() + 1).toString().padStart(2, '0')}/${endDate.getFullYear()}`;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không thể tính ngày kết thúc' });
      } finally {
        this.renewLoading = false;
      }
    },

    async submitRenew() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Vui lòng điền đầy đủ thông tin bắt buộc!' });
        return;
      }
      try {
        this.renewLoading = true;
        const payload = new FormData();
        let phone = this.renewItem.phoneNumber || '';
        if (phone.startsWith('+84')) {
          phone = '0' + phone.slice(3);
        }
        payload.append('phoneNumber', phone);
        if (this.renewItem.accountId) {
          payload.append('accountId', this.renewItem.accountId);
        }
        if (this.renewForm.name) payload.append('name', this.renewForm.name);
        payload.append('servicePackageId', this.renewForm.selectedServicePackage || '');
        payload.append('reminderMethod', this.renewForm.reminderMethod ?? '');
        if (this.renewForm.startDate) {
          payload.append('startDate', convertDateToTimestamp(this.renewForm.startDate));
        }
        if (this.renewForm.endDate) {
          payload.append('endDate', convertDateToTimestamp(this.renewForm.endDate));
        }
        await this.$api.post('UserPackage', payload);
        this.$toastr.s({ title: 'Thành công!', msg: 'Gia hạn gói dịch vụ thành công!' });
        this.showRenewModal = false;
        this.loadData();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi!', msg: e?.message || 'Có lỗi xảy ra khi gia hạn gói dịch vụ' });
      } finally {
        this.renewLoading = false;
      }
    },
    deleteItem(item) {
      this.currentItem = item;
      this.$bvModal.show('reason-modal');
    },
    addItemDsmes(item) {
      this.currentItem = item;
      this.coachList = this.coaches;
      this.$bvModal.show('form-modal');
    },
    opentSurveyResult(item) {
      this.currentItem = item;
      this.$bvModal.show('modal-survey-result');
    },
    copyItem(item) {
      this.$router.push({
        name: 'customer_receives_detail',
        params: {
          form_type: 'copy',
          id: item.id,
        },
      });
    },
    getNameOf(key, value) {
      switch (key) {
        case 'coach':
          return this?.coaches?.find((item) => item.value == value) ?? null;
        case 'course':
          return this.courses?.find((item) => item.value == value) ?? null;
        // case 'partner':
        //   return this.partners?.find((item) => item.id == value) ?? null;
        default:
          return (
            this.optionsStatus?.find((item) => item.value == value) ?? null
          );
      }
    },
    getStatusOf(key, item) {
      return !!item[key];
    },

    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      // Create a new FormData object
      const formData = new FormData();
      const keyBoolean = [
        'followOaFlag',
        'joinGroupchatFlag',
        'downloadAppFlag',
        'loginFlag',
        'boardingBookingFlag',
        'boardingTestingFlag',
        'boardingDoneFlag',
        'joinHeathCourseFlag',
        'isDeleted',
      ];
      // Append properties of the item object to formData

      Object.keys(item).forEach((key) => {
        if (['callCount', 'gender', 'timeAccepted'].includes(key)) {
          return;
        }
        // Xử lý đặc biệt cho status field - bỏ qua falsy check để giữ giá trị 0
        if (key === 'status') {
          formData.append(key, item[key] !== null && item[key] !== undefined ? item[key] : '');
          return;
        }
        formData.append(
          key,
          keyBoolean.includes(key) ? !!item[key] : item[key] || '',
        );
      });
      // Send the FormData using the PUT method

      try {
        await this.$api.put(`/CustomerReceives/${item.id}`, formData, { timeout: 60000 });
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
      } catch (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
      this.loadData();
    },
    async confirmSendSms() {
      console.log('this.selectedOption', this.selectedOption);
      if (
        this.selectedKey === 'joinGroupchatFlag' &&
        this.selectedEvent === true
      ) {
        this.changeStatus({
          ...this.selectedItem,
          [this.selectedKey]: this.selectedEvent,
        });
        try {
          this.loading = true;
          const formData = {
            PhoneNumber: this.selectedItemModalPhoneNumber,
          };
          await this.$api.post(
            'CustomerReceives/UserLoginInformation',
            formData,
          );
        } catch (error) {
          console.log('Send Sms Error');
          this.loading = false;
        } finally {
          this.$toastr.s({
            title: 'Gửi thành công',
            msg: 'Đã gửi thông tin đến người dùng',
          });
        }
      } else if (this.selectedOption.formProperty == 'bookingSend') {
        try {
          this.loading = true;
          const formData = {
            phone: this.selectedOption.optionsArr.phoneNumber,
            packageId: this.selectedOption.optionsArr.packageId,
            Name: this.selectedOption.optionsArr.name,
          };
          await this.$api.post('ZaloZnsLog/BookingZns', formData, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          this.$toastr.s({
            title: 'Gửi thành công',
            msg: 'Đã gửi link đặt hẹn đến Zalo của khách hàng',
          });
        } catch (error) {
          this.$toastr.e({
            title: 'Đã xảy ra lỗi',
            msg: 'Không thể gửi đã có lỗi',
          });
          this.loading = false;
        } finally {
          this.loading = false;
        }
      } else {
        // console.log("SelectedWeeksTime", this.SelectedWeeksTime)
        const extract = extractStartDate(this.SelectedWeeksTime.value);

        const formData = new FormData();
        formData.append(
          'PackageAccountTransactionId',
          this.SelectedWeeksTime.optionsArr.packageAccountTransactionId,
        );
        formData.append(
          'PackageId',
          this.SelectedWeeksTime.optionsArr.packageId,
        );
        formData.append('Id', this.SelectedWeeksTime.optionsArr.id);
        formData.append('ActivationDate', convertToTimestamp(extract));

        try {
          this.loading = true;
          const respone = await this.$api.put(
            '/Package/UpdatePackageAccountActived',
            formData,
          );
          // console.log("respone", respone)
          if (respone != null) {
            this.$toastr.s({
              title: 'Thay đổi thành công',
              msg: 'Đã thay đổi thành công lộ trình',
            });
            this.showSelect = false;
          }
        } catch {
          this.$toastr.e({
            title: 'Thất bại',
          });
        }
      }
      this.loading = false;
      this.isModalVisible = false;
      this.loadData();
    },

    async loadData() {
      this.$store.commit('context/setLoading', true);
      // Reset để cho phép fetch lại package info
      this.lastFetchedAccountIds = null;
      try {
        const response = await this.$api.get('CustomerReceives', {
          params: this.searchParams,
        });

        const { data, meta } = response;

        var filteredData = data || [];

        if (!this.isAssignPermission) {
          filteredData = filteredData.filter(
            (el) => el.coachId === this.coachId,
          );
        }


        this.data = filteredData.map((el) => ({ ...el }));
        this.paging.total = meta.total;
        this.$store.commit('context/setLoading', false);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error.message,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (status == 1) return 'active';
      if (status == 2) return 'warning-color';
      return 'inactive';
    },
    // searchDebounce(value) {
    //   this.filter.courseName = value;
    //   this.resetPaging();
    // },
    searchDebounce(value) {
      this.searchText = value;

      if (this._searchTimer) {
        clearTimeout(this._searchTimer);
      }

      this._searchTimer = setTimeout(() => {
        if (this.isPhone(value)) {
          let phone = value.replace(/\D/g, '');
          if (phone.startsWith('0')) {
            phone = '+84' + phone.substring(1);
          } else if (!phone.startsWith('84')) {
            phone = '+84' + phone;
          } else {
            phone = '+' + phone;
          }
          this.filter.phoneNumber = phone;
          this.filter.name = null;
        } else {
          this.filter.name = value;
          this.filter.phoneNumber = null;
        }

        this.resetPaging();
      }, 2000);
    },
    isPhone(value) {
      if (!value) return false;
      const digits = value.replace(/\D/g, "");
      return digits.length >= 8 && digits.length <= 15;
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    // Distinct chạy dưới DB nên chỉ vài chục chuỗi, rẻ hơn nhiều so với cách
    // DetailModal đang làm là tải hết bản ghi rồi gom trùng ở client.
    async getOnboardGroups() {
      try {
        const { meta, data } = await this.$api.get(
          'CustomerReceives/OnboardGroups',
        );
        if (!meta.success) return;
        // "Khách hàng cá nhân" = khách không có nhóm onboard; BE nhận giá trị __INDIVIDUAL__
        this.onboardGroupOptions = [
          { text: 'Khách hàng cá nhân', value: '__INDIVIDUAL__' },
          ...(data || []).map((name) => ({
            text: name,
            value: name,
          })),
        ];
      } catch {
        // Dropdown lọc hỏng thì thôi, không chặn cả màn
      }
    },
    // Nhóm dùng chung lấy từ DB, còn tên nhóm phải hỏi Zalo OA (tối đa 50 nhóm mỗi lượt)
    async loadSharedZaloGroups() {
      try {
        const { meta, data } = await this.$api.get('CustomerReceives/SharedZaloGroups');
        if (!meta.success || !data?.length) return;

        const names = {};
        for (let offset = 0; offset < 1000; offset += 50) {
          const res = await this.$api.get('/ZaloZnsLog/GetValidGroupOA', {
            params: { offset, count: 50 },
          });
          const groups = res?.data?.groups || [];
          groups.forEach((g) => {
            names[g.group_id] = g.name;
          });
          if (groups.length < 50 || offset + 50 >= parseInt(res?.data?.total || 0)) break;
        }

        this.sharedZaloGroupOptions = data
          .map((id) => ({ text: names[id] || id, value: id }))
          .sort((a, b) => a.text.localeCompare(b.text));
      } catch {
        // Dropdown lọc hỏng thì thôi, không chặn cả màn
      }
    },
    getSearchDataPrepare() {
      this.$api
        .get('CustomerReceives/PrepareSearchFormItem')
        .then(({ data }) => {
          const { coaches } = data;
          this.coaches = coaches?.map((c) => {
            return {
              text: c?.coachName,
              value: c?.coachId,
              courses: c?.courseIds,
              partners: c?.customerPartnerId,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        });
    },
    async GetPackage() {
      await this.$api
        .get('/Package')
        .then((response) => {
          this.packagesName = response.data;
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },
  },
  async handleExport() {
    this.$store.commit('context/setLoading', true);
    const params = {
      downloadFilters: this.selectedItems?.map((el) => ({
        id: el.id,
      })),
    };
    this.$api
      .post('/Product/Product-Download', params, {
        responseType: 'blob',
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${this.getFileName(res.headers['content-disposition'])}`,
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Xuất kết quả lỗi',
        });
      })
      .finally(() => {
        this.$store.commit('context/setLoading', false);
      });
  },

  async created() {
    this.$store.commit('context/setLoading', true);
    this.coachId = this.currentUser?.id;

    // Restore filter từ localStorage trước khi fetch để chỉ gọi loadData 1 lần
    const savedParams = localStorage.getItem('filterCourseData');
    if (savedParams) {
      const convertJsonStorage = JSON.parse(savedParams);
      this.filter.courseName = convertJsonStorage.courseName;
    }

    try {
      //     await this.UpdateAppFlags();
      await Promise.all([
        this.loadData(),
        this.getSearchDataPrepare(),
        this.GetPackage(),
        this.getOnboardGroups(),
      ]);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      this.$store.commit('context/setLoading', false);
    }
    this.selectedWeek = null;
  },
};
</script>

<style lang="scss" scoped>
.week-card {
  display: inline-flex;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;

  &--empty {
    background: #ffc107;
    color: #856404;
    justify-content: center;
    min-width: 70px;
    font-size: 9px;
    font-weight: 500;
  }

  &__day, &__week {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3px 6px;
    border-radius: 4px;
    min-width: 40px;
  }

  &__day {
    background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
    color: #fff;
  }

  &__week {
    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
    color: #fff;
  }

  &__label {
    font-size: 8px;
    text-transform: uppercase;
    opacity: 0.9;
    letter-spacing: 0.3px;
  }

  &__value {
    font-size: 11px;
    font-weight: 700;
  }
}

.package-info-cards {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.package-card {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 9px;
  max-width: 100%;

  &--old {
    background: #d4edfc;
    color: #1a6b8a;
    border: 1px solid #a8d4ef;
  }

  &--new {
    background: #d9f2d0;
    color: #2d6a2d;
    border: 1px solid #a8dba0;
  }

  &--package {
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffc107;
  }

  &__label {
    font-weight: 700;
  }

  &__value {
    font-weight: 600;
  }
}

.w-250 {
  width: 250px;
}

::v-deep(.table-responsive) {
  overflow-x: initial !important;
}

::v-deep .partner {
  max-width: 200px;
}

::v-deep .partner .multiselect__content-wrapper {
  min-width: 200%;
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #00c7f9;
  }

  &.warning-color {
    background-color: #ff5756;
  }
}

.customer-list-page__body__tabs::v-deep {
  margin: 0 -2rem -2rem;

  a.nav-link {
    border: 0;

    &.active {
      font-weight: 600;
      color: #01645a !important;
      border-bottom: 2px solid #01645a;
    }
  }

  li.nav-item {
    a.nav-link:hover {
      color: #333;
    }
  }

  .tab-content {
    display: none;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}

.mw-400 {
  min-width: 400px;
}

.mw-200 {
  min-width: 200px;
}

.mw-250 {
  min-width: 250px;
}

.w-40 {
  width: 40px;
}

.mw-157 {
  width: 157px;
}

.status-options {
  background: white;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.status-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.status-item:hover {
  background-color: #f5f5f5;
}

.menu-icon {
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
}

// .svg-icon {
//   width: 1rem;
//   height: 1rem;
// }

.navi-link {
  display: flex;
  align-items: center;
  padding: 0.5rem;
}

.submenu-level2 {
  border-left: 2px solid #e4e6ef;
  padding-left: 0.5rem;

  .navi-link {
    padding: 0.4rem 0.5rem;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f3f6f9;
    }
  }
}

.badge-no-zalo {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(139, 92, 246, 0.12);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.3);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}

.badge-shared-group {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(37, 154, 187, 0.12);
  color: #1b7f9c;
  border: 1px solid rgba(37, 154, 187, 0.35);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}
</style>
